import React, { useEffect, useState } from 'react';
import { IPageProperties } from 'Root/Shared/utils/data/buildTypedPage';
import PuxWysiwyg, { PuxWysiwygHtmlBodyType } from '../PuxWysiwyg/PuxWysiwyg';

interface CustomInfoBarProps {
    background?: string | null,
    text: PuxWysiwygHtmlBodyType,
    resetDate: string | null,
    path?: string
}

function parseValidDate(value: string | null | undefined): Date | null {
    if (!value) return null;
    const date = new Date(value);
    return isNaN(date.getTime()) ? null : date;
}


const getInfoBarClassName = (background?: string | null) => {
    const classes = [`InfoBar`];
    const allowedBackgrounds = [`InfoBar--yellow`, `InfoBar--darkBlue`];

    if (background && allowedBackgrounds.includes(background)) {
        classes.push(background);
    }

    return classes.join(` `);
}

const CustomInfoBar = (props: CustomInfoBarProps) => {
    // const [visible, setVisible] = useState(false);
    const [visible, setVisible] = useState(true);
    const id = `${props.path}-info-bar`;
    
    /*
    const getCookie = (name: string) => {
        const match = document.cookie.match(new RegExp(`(^| )${encodeURIComponent(name)}=([^;]+)`));
        return match ? decodeURIComponent(match[2]) : null;
    }

    const setCookie = (name: string, value: string) => {
        const date = new Date();
        date.setTime(date.getTime() + (365 * 24 * 60 * 60 * 1000));
        const expires = `; expires=${date.toUTCString()}`;
        document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}${expires}; path=/`;
    }

    useEffect(() => {
        const cookieValue = getCookie(id);
        const now = new Date();
        const propDate = parseValidDate(props.resetDate);

        if (!cookieValue) {
            const newCookie = {
                visible: true,
                resetDate: propDate
            };
            setCookie(id, JSON.stringify(newCookie));
            setVisible(true);
        } else {

            const parsed = JSON.parse(cookieValue);
            const cookieVisible = parsed.visible;
            const cookieDate = parseValidDate(parsed.resetDate);


            const datesMatch = (cookieDate && propDate)
                ? cookieDate.getTime() === propDate.getTime()
                : cookieDate === propDate;

            if (datesMatch) {
                if (propDate && cookieVisible) {
                    setVisible(propDate <= now);
                } else {
                    setVisible(cookieVisible);
                }

            } else {
                if (propDate) {
                    setVisible(propDate <= now);
                    setCookie(id, JSON.stringify({ visible: true, resetDate: propDate.toISOString() }));
                } else {
                    setVisible(true);
                    setCookie(id, JSON.stringify({ visible: true, resetDate: null }));
                }
            }

        }
    }, [id, props.resetDate]);
    */

    function hideInfoBar() {
        setVisible(false);
        /*
        const propDate = parseValidDate(props.resetDate);

        const cookieValue = JSON.stringify({
            visible: false,
            resetDate: propDate ? propDate.toISOString() : null
        });
        setCookie(id, cookieValue);
        */
    }

    if (!visible) {
        return null;
    }

    return (
        <div className={getInfoBarClassName(props.background)}>
            <div>
                <PuxWysiwyg content={props.text} inline />
            </div>
            <button onClick={hideInfoBar}></button>
        </div>
    );
}

export default CustomInfoBar;
